// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/********************************************
	BREAKPOINT WIDTHS
********************************************/
/********************************************
	FONTS
********************************************/
/********************************************
	COLOURS
********************************************/
.carousel .control-arrow, .carousel.carousel-slider .control-arrow {
  -webkit-transition: all 0.25s ease-in;
  -moz-transition: all 0.25s ease-in;
  -ms-transition: all 0.25s ease-in;
  -o-transition: all 0.25s ease-in;
  transition: all 0.25s ease-in;
  opacity: 0.4;
  filter: alpha(opacity=40);
  position: absolute;
  z-index: 2;
  top: 20px;
  background: none;
  border: 0;
  font-size: 32px;
  cursor: pointer; }
  .carousel .control-arrow:focus, .carousel .control-arrow:hover {
    opacity: 1;
    filter: alpha(opacity=100); }
  .carousel .control-arrow:before, .carousel.carousel-slider .control-arrow:before {
    margin: 0 5px;
    display: inline-block;
    border-top: 8px solid transparent;
    border-bottom: 8px solid transparent;
    content: ''; }
  .carousel .control-disabled.control-arrow {
    opacity: 0;
    filter: alpha(opacity=0);
    cursor: inherit;
    display: none; }
  .carousel .control-prev.control-arrow {
    left: 0; }
    .carousel .control-prev.control-arrow:before {
      border-right: 8px solid #fff; }
  .carousel .control-next.control-arrow {
    right: 0; }
    .carousel .control-next.control-arrow:before {
      border-left: 8px solid #fff; }

.carousel-root {
  outline: none; }

.carousel {
  position: relative;
  width: 100%; }
  .carousel * {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box; }
  .carousel img {
    width: 100%;
    display: inline-block;
    pointer-events: none; }
  .carousel .carousel {
    position: relative; }
  .carousel .control-arrow {
    outline: 0;
    border: 0;
    background: none;
    top: 50%;
    margin-top: -13px;
    font-size: 18px; }
  .carousel .thumbs-wrapper {
    margin: 20px;
    overflow: hidden; }
  .carousel .thumbs {
    -webkit-transition: all 0.15s ease-in;
    -moz-transition: all 0.15s ease-in;
    -ms-transition: all 0.15s ease-in;
    -o-transition: all 0.15s ease-in;
    transition: all 0.15s ease-in;
    -webkit-transform: translate3d(0, 0, 0);
    -moz-transform: translate3d(0, 0, 0);
    -ms-transform: translate3d(0, 0, 0);
    -o-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
    position: relative;
    list-style: none;
    white-space: nowrap; }
  .carousel .thumb {
    -webkit-transition: border 0.15s ease-in;
    -moz-transition: border 0.15s ease-in;
    -ms-transition: border 0.15s ease-in;
    -o-transition: border 0.15s ease-in;
    transition: border 0.15s ease-in;
    display: inline-block;
    margin-right: 6px;
    white-space: nowrap;
    overflow: hidden;
    border: 3px solid #fff;
    padding: 2px; }
    .carousel .thumb:focus {
      border: 3px solid #ccc;
      outline: none; }
    .carousel .thumb.selected, .carousel .thumb:hover {
      border: 3px solid #333; }
    .carousel .thumb img {
      vertical-align: top; }
  .carousel.carousel-slider {
    position: relative;
    margin: 0;
    overflow: hidden; }
    .carousel.carousel-slider .control-arrow {
      top: 0;
      color: #fff;
      font-size: 26px;
      bottom: 0;
      margin-top: 0;
      padding: 5px; }
      .carousel.carousel-slider .control-arrow:hover {
        background: rgba(0, 0, 0, 0.2); }
  .carousel .slider-wrapper {
    overflow: hidden;
    margin: auto;
    width: 100%;
    -webkit-transition: height 0.15s ease-in;
    -moz-transition: height 0.15s ease-in;
    -ms-transition: height 0.15s ease-in;
    -o-transition: height 0.15s ease-in;
    transition: height 0.15s ease-in; }
    .carousel .slider-wrapper.axis-horizontal .slider {
      -ms-box-orient: horizontal;
      display: -webkit-box;
      display: -moz-box;
      display: -ms-flexbox;
      display: -moz-flex;
      display: -webkit-flex;
      display: flex; }
      .carousel .slider-wrapper.axis-horizontal .slider .slide {
        flex-direction: column;
        flex-flow: column; }
    .carousel .slider-wrapper.axis-vertical {
      -ms-box-orient: horizontal;
      display: -webkit-box;
      display: -moz-box;
      display: -ms-flexbox;
      display: -moz-flex;
      display: -webkit-flex;
      display: flex; }
      .carousel .slider-wrapper.axis-vertical .slider {
        -webkit-flex-direction: column;
        flex-direction: column; }
  .carousel .slider {
    margin: 0;
    padding: 0;
    position: relative;
    list-style: none;
    width: 100%; }
    .carousel .slider.animated {
      -webkit-transition: all 0.35s ease-in-out;
      -moz-transition: all 0.35s ease-in-out;
      -ms-transition: all 0.35s ease-in-out;
      -o-transition: all 0.35s ease-in-out;
      transition: all 0.35s ease-in-out; }
  .carousel .slide {
    min-width: 100%;
    margin: 0;
    position: relative;
    text-align: center; }
    .carousel .slide img {
      width: 100%;
      vertical-align: top;
      border: 0; }
    .carousel .slide iframe {
      display: inline-block;
      width: calc(100% - 80px);
      margin: 0 40px 40px;
      border: 0; }
    .carousel .slide .legend {
      -webkit-transition: all 0.5s ease-in-out;
      -moz-transition: all 0.5s ease-in-out;
      -ms-transition: all 0.5s ease-in-out;
      -o-transition: all 0.5s ease-in-out;
      transition: all 0.5s ease-in-out;
      position: absolute;
      bottom: 40px;
      left: 50%;
      margin-left: -45%;
      width: 90%;
      border-radius: 10px;
      background: #000;
      color: #fff;
      padding: 10px;
      font-size: 12px;
      text-align: center;
      opacity: 0.25;
      -webkit-transition: opacity 0.35s ease-in-out;
      -moz-transition: opacity 0.35s ease-in-out;
      -ms-transition: opacity 0.35s ease-in-out;
      -o-transition: opacity 0.35s ease-in-out;
      transition: opacity 0.35s ease-in-out; }
  .carousel .control-dots {
    position: absolute;
    bottom: 0;
    margin: 10px 0;
    padding: 0;
    text-align: center;
    width: 100%;
    z-index: 1; }
    @media (min-width: 960px) {
      .carousel .control-dots {
        bottom: 0; } }
    .carousel .control-dots .dot {
      -webkit-transition: opacity 0.25s ease-in;
      -moz-transition: opacity 0.25s ease-in;
      -ms-transition: opacity 0.25s ease-in;
      -o-transition: opacity 0.25s ease-in;
      transition: opacity 0.25s ease-in;
      opacity: 0.3;
      filter: alpha(opacity=30);
      box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.9);
      background: #fff;
      border-radius: 50%;
      width: 8px;
      height: 8px;
      cursor: pointer;
      display: inline-block;
      margin: 0 8px; }
      .carousel .control-dots .dot.selected, .carousel .control-dots .dot:hover {
        opacity: 1;
        filter: alpha(opacity=100); }
  .carousel .carousel-status {
    position: absolute;
    top: 0;
    right: 0;
    padding: 5px;
    font-size: 10px;
    text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.9);
    color: #fff; }
  .carousel:hover .slide .legend {
    opacity: 1; }
`, "",{"version":3,"sources":["webpack://./node_modules/react-responsive-carousel/lib/styles/carousel.css"],"names":[],"mappings":"AAAA;;4CAE4C;AAC5C;;4CAE4C;AAC5C;;4CAE4C;AAC5C;EACE,qCAAqC;EACrC,kCAAkC;EAClC,iCAAiC;EACjC,gCAAgC;EAChC,6BAA6B;EAC7B,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,SAAS;EACT,eAAe;EACf,eAAe,EAAE;EACjB;IACE,UAAU;IACV,0BAA0B,EAAE;EAC9B;IACE,aAAa;IACb,qBAAqB;IACrB,iCAAiC;IACjC,oCAAoC;IACpC,WAAW,EAAE;EACf;IACE,UAAU;IACV,wBAAwB;IACxB,eAAe;IACf,aAAa,EAAE;EACjB;IACE,OAAO,EAAE;IACT;MACE,4BAA4B,EAAE;EAClC;IACE,QAAQ,EAAE;IACV;MACE,2BAA2B,EAAE;;AAEnC;EACE,aAAa,EAAE;;AAEjB;EACE,kBAAkB;EAClB,WAAW,EAAE;EACb;IACE,8BAA8B;IAC9B,2BAA2B;IAC3B,sBAAsB,EAAE;EAC1B;IACE,WAAW;IACX,qBAAqB;IACrB,oBAAoB,EAAE;EACxB;IACE,kBAAkB,EAAE;EACtB;IACE,UAAU;IACV,SAAS;IACT,gBAAgB;IAChB,QAAQ;IACR,iBAAiB;IACjB,eAAe,EAAE;EACnB;IACE,YAAY;IACZ,gBAAgB,EAAE;EACpB;IACE,qCAAqC;IACrC,kCAAkC;IAClC,iCAAiC;IACjC,gCAAgC;IAChC,6BAA6B;IAC7B,uCAAuC;IACvC,oCAAoC;IACpC,mCAAmC;IACnC,kCAAkC;IAClC,+BAA+B;IAC/B,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB,EAAE;EACvB;IACE,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;IACnC,gCAAgC;IAChC,qBAAqB;IACrB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,sBAAsB;IACtB,YAAY,EAAE;IACd;MACE,sBAAsB;MACtB,aAAa,EAAE;IACjB;MACE,sBAAsB,EAAE;IAC1B;MACE,mBAAmB,EAAE;EACzB;IACE,kBAAkB;IAClB,SAAS;IACT,gBAAgB,EAAE;IAClB;MACE,MAAM;MACN,WAAW;MACX,eAAe;MACf,SAAS;MACT,aAAa;MACb,YAAY,EAAE;MACd;QACE,8BAA8B,EAAE;EACtC;IACE,gBAAgB;IAChB,YAAY;IACZ,WAAW;IACX,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;IACnC,gCAAgC,EAAE;IAClC;MACE,0BAA0B;MAC1B,oBAAoB;MACpB,iBAAiB;MACjB,oBAAoB;MACpB,kBAAkB;MAClB,qBAAqB;MACrB,aAAa,EAAE;MACf;QACE,sBAAsB;QACtB,iBAAiB,EAAE;IACvB;MACE,0BAA0B;MAC1B,oBAAoB;MACpB,iBAAiB;MACjB,oBAAoB;MACpB,kBAAkB;MAClB,qBAAqB;MACrB,aAAa,EAAE;MACf;QACE,8BAA8B;QAC9B,sBAAsB,EAAE;EAC9B;IACE,SAAS;IACT,UAAU;IACV,kBAAkB;IAClB,gBAAgB;IAChB,WAAW,EAAE;IACb;MACE,yCAAyC;MACzC,sCAAsC;MACtC,qCAAqC;MACrC,oCAAoC;MACpC,iCAAiC,EAAE;EACvC;IACE,eAAe;IACf,SAAS;IACT,kBAAkB;IAClB,kBAAkB,EAAE;IACpB;MACE,WAAW;MACX,mBAAmB;MACnB,SAAS,EAAE;IACb;MACE,qBAAqB;MACrB,wBAAwB;MACxB,mBAAmB;MACnB,SAAS,EAAE;IACb;MACE,wCAAwC;MACxC,qCAAqC;MACrC,oCAAoC;MACpC,mCAAmC;MACnC,gCAAgC;MAChC,kBAAkB;MAClB,YAAY;MACZ,SAAS;MACT,iBAAiB;MACjB,UAAU;MACV,mBAAmB;MACnB,gBAAgB;MAChB,WAAW;MACX,aAAa;MACb,eAAe;MACf,kBAAkB;MAClB,aAAa;MACb,6CAA6C;MAC7C,0CAA0C;MAC1C,yCAAyC;MACzC,wCAAwC;MACxC,qCAAqC,EAAE;EAC3C;IACE,kBAAkB;IAClB,SAAS;IACT,cAAc;IACd,UAAU;IACV,kBAAkB;IAClB,WAAW;IACX,UAAU,EAAE;IACZ;MACE;QACE,SAAS,EAAE,EAAE;IACjB;MACE,yCAAyC;MACzC,sCAAsC;MACtC,qCAAqC;MACrC,oCAAoC;MACpC,iCAAiC;MACjC,YAAY;MACZ,yBAAyB;MACzB,0CAA0C;MAC1C,gBAAgB;MAChB,kBAAkB;MAClB,UAAU;MACV,WAAW;MACX,eAAe;MACf,qBAAqB;MACrB,aAAa,EAAE;MACf;QACE,UAAU;QACV,0BAA0B,EAAE;EAClC;IACE,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,YAAY;IACZ,eAAe;IACf,2CAA2C;IAC3C,WAAW,EAAE;EACf;IACE,UAAU,EAAE","sourcesContent":["/********************************************\n\tBREAKPOINT WIDTHS\n********************************************/\n/********************************************\n\tFONTS\n********************************************/\n/********************************************\n\tCOLOURS\n********************************************/\n.carousel .control-arrow, .carousel.carousel-slider .control-arrow {\n  -webkit-transition: all 0.25s ease-in;\n  -moz-transition: all 0.25s ease-in;\n  -ms-transition: all 0.25s ease-in;\n  -o-transition: all 0.25s ease-in;\n  transition: all 0.25s ease-in;\n  opacity: 0.4;\n  filter: alpha(opacity=40);\n  position: absolute;\n  z-index: 2;\n  top: 20px;\n  background: none;\n  border: 0;\n  font-size: 32px;\n  cursor: pointer; }\n  .carousel .control-arrow:focus, .carousel .control-arrow:hover {\n    opacity: 1;\n    filter: alpha(opacity=100); }\n  .carousel .control-arrow:before, .carousel.carousel-slider .control-arrow:before {\n    margin: 0 5px;\n    display: inline-block;\n    border-top: 8px solid transparent;\n    border-bottom: 8px solid transparent;\n    content: ''; }\n  .carousel .control-disabled.control-arrow {\n    opacity: 0;\n    filter: alpha(opacity=0);\n    cursor: inherit;\n    display: none; }\n  .carousel .control-prev.control-arrow {\n    left: 0; }\n    .carousel .control-prev.control-arrow:before {\n      border-right: 8px solid #fff; }\n  .carousel .control-next.control-arrow {\n    right: 0; }\n    .carousel .control-next.control-arrow:before {\n      border-left: 8px solid #fff; }\n\n.carousel-root {\n  outline: none; }\n\n.carousel {\n  position: relative;\n  width: 100%; }\n  .carousel * {\n    -webkit-box-sizing: border-box;\n    -moz-box-sizing: border-box;\n    box-sizing: border-box; }\n  .carousel img {\n    width: 100%;\n    display: inline-block;\n    pointer-events: none; }\n  .carousel .carousel {\n    position: relative; }\n  .carousel .control-arrow {\n    outline: 0;\n    border: 0;\n    background: none;\n    top: 50%;\n    margin-top: -13px;\n    font-size: 18px; }\n  .carousel .thumbs-wrapper {\n    margin: 20px;\n    overflow: hidden; }\n  .carousel .thumbs {\n    -webkit-transition: all 0.15s ease-in;\n    -moz-transition: all 0.15s ease-in;\n    -ms-transition: all 0.15s ease-in;\n    -o-transition: all 0.15s ease-in;\n    transition: all 0.15s ease-in;\n    -webkit-transform: translate3d(0, 0, 0);\n    -moz-transform: translate3d(0, 0, 0);\n    -ms-transform: translate3d(0, 0, 0);\n    -o-transform: translate3d(0, 0, 0);\n    transform: translate3d(0, 0, 0);\n    position: relative;\n    list-style: none;\n    white-space: nowrap; }\n  .carousel .thumb {\n    -webkit-transition: border 0.15s ease-in;\n    -moz-transition: border 0.15s ease-in;\n    -ms-transition: border 0.15s ease-in;\n    -o-transition: border 0.15s ease-in;\n    transition: border 0.15s ease-in;\n    display: inline-block;\n    margin-right: 6px;\n    white-space: nowrap;\n    overflow: hidden;\n    border: 3px solid #fff;\n    padding: 2px; }\n    .carousel .thumb:focus {\n      border: 3px solid #ccc;\n      outline: none; }\n    .carousel .thumb.selected, .carousel .thumb:hover {\n      border: 3px solid #333; }\n    .carousel .thumb img {\n      vertical-align: top; }\n  .carousel.carousel-slider {\n    position: relative;\n    margin: 0;\n    overflow: hidden; }\n    .carousel.carousel-slider .control-arrow {\n      top: 0;\n      color: #fff;\n      font-size: 26px;\n      bottom: 0;\n      margin-top: 0;\n      padding: 5px; }\n      .carousel.carousel-slider .control-arrow:hover {\n        background: rgba(0, 0, 0, 0.2); }\n  .carousel .slider-wrapper {\n    overflow: hidden;\n    margin: auto;\n    width: 100%;\n    -webkit-transition: height 0.15s ease-in;\n    -moz-transition: height 0.15s ease-in;\n    -ms-transition: height 0.15s ease-in;\n    -o-transition: height 0.15s ease-in;\n    transition: height 0.15s ease-in; }\n    .carousel .slider-wrapper.axis-horizontal .slider {\n      -ms-box-orient: horizontal;\n      display: -webkit-box;\n      display: -moz-box;\n      display: -ms-flexbox;\n      display: -moz-flex;\n      display: -webkit-flex;\n      display: flex; }\n      .carousel .slider-wrapper.axis-horizontal .slider .slide {\n        flex-direction: column;\n        flex-flow: column; }\n    .carousel .slider-wrapper.axis-vertical {\n      -ms-box-orient: horizontal;\n      display: -webkit-box;\n      display: -moz-box;\n      display: -ms-flexbox;\n      display: -moz-flex;\n      display: -webkit-flex;\n      display: flex; }\n      .carousel .slider-wrapper.axis-vertical .slider {\n        -webkit-flex-direction: column;\n        flex-direction: column; }\n  .carousel .slider {\n    margin: 0;\n    padding: 0;\n    position: relative;\n    list-style: none;\n    width: 100%; }\n    .carousel .slider.animated {\n      -webkit-transition: all 0.35s ease-in-out;\n      -moz-transition: all 0.35s ease-in-out;\n      -ms-transition: all 0.35s ease-in-out;\n      -o-transition: all 0.35s ease-in-out;\n      transition: all 0.35s ease-in-out; }\n  .carousel .slide {\n    min-width: 100%;\n    margin: 0;\n    position: relative;\n    text-align: center; }\n    .carousel .slide img {\n      width: 100%;\n      vertical-align: top;\n      border: 0; }\n    .carousel .slide iframe {\n      display: inline-block;\n      width: calc(100% - 80px);\n      margin: 0 40px 40px;\n      border: 0; }\n    .carousel .slide .legend {\n      -webkit-transition: all 0.5s ease-in-out;\n      -moz-transition: all 0.5s ease-in-out;\n      -ms-transition: all 0.5s ease-in-out;\n      -o-transition: all 0.5s ease-in-out;\n      transition: all 0.5s ease-in-out;\n      position: absolute;\n      bottom: 40px;\n      left: 50%;\n      margin-left: -45%;\n      width: 90%;\n      border-radius: 10px;\n      background: #000;\n      color: #fff;\n      padding: 10px;\n      font-size: 12px;\n      text-align: center;\n      opacity: 0.25;\n      -webkit-transition: opacity 0.35s ease-in-out;\n      -moz-transition: opacity 0.35s ease-in-out;\n      -ms-transition: opacity 0.35s ease-in-out;\n      -o-transition: opacity 0.35s ease-in-out;\n      transition: opacity 0.35s ease-in-out; }\n  .carousel .control-dots {\n    position: absolute;\n    bottom: 0;\n    margin: 10px 0;\n    padding: 0;\n    text-align: center;\n    width: 100%;\n    z-index: 1; }\n    @media (min-width: 960px) {\n      .carousel .control-dots {\n        bottom: 0; } }\n    .carousel .control-dots .dot {\n      -webkit-transition: opacity 0.25s ease-in;\n      -moz-transition: opacity 0.25s ease-in;\n      -ms-transition: opacity 0.25s ease-in;\n      -o-transition: opacity 0.25s ease-in;\n      transition: opacity 0.25s ease-in;\n      opacity: 0.3;\n      filter: alpha(opacity=30);\n      box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.9);\n      background: #fff;\n      border-radius: 50%;\n      width: 8px;\n      height: 8px;\n      cursor: pointer;\n      display: inline-block;\n      margin: 0 8px; }\n      .carousel .control-dots .dot.selected, .carousel .control-dots .dot:hover {\n        opacity: 1;\n        filter: alpha(opacity=100); }\n  .carousel .carousel-status {\n    position: absolute;\n    top: 0;\n    right: 0;\n    padding: 5px;\n    font-size: 10px;\n    text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.9);\n    color: #fff; }\n  .carousel:hover .slide .legend {\n    opacity: 1; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
